"use client"

import Title from "@/components/common/Typography/Title"
import { Button, Card, Col, Row } from "antd"
import TourProgramItem from "./TourProgramItem"
import { useTour } from "@/hooks/tour/useTour"
import { useIsDesktop } from "@/hooks/app/useIsDesktop"
import { useMemo, useState } from "react"
import { useTranslation } from "react-i18next"

const DEFAULT_VISIBLE_DAYS = 3

const TourProgram = () => {
  const isDesktop = useIsDesktop()
  const { tour: { data: tour } } = useTour()
  const { t } = useTranslation()
  const [showAllDays, setShowAllDays] = useState(false)

  const itinerary = tour.itinerary || []
  const hiddenCount = Math.max(0, itinerary.length - DEFAULT_VISIBLE_DAYS)
  const visibleItinerary = useMemo(
    () => (showAllDays ? itinerary : itinerary.slice(0, DEFAULT_VISIBLE_DAYS)),
    [itinerary, showAllDays]
  )

  if (!itinerary.length) return null

  return (
    <Col id="tour-section-program" span={24}>
      <Card
        className="tour-detail__programs tour-detail__section"
        style={isDesktop ? {} : { borderRadius: 0 }}
        styles={{
          body: {
            padding: 0,
            paddingBottom: "1.2rem",
          },
        }}
      >
        <Row
          justify="space-between"
          align="middle"
          className="passenger__form--row tour-detail__program-header"
        >
          <Col>
            <Title level={4} className="tour-detail__section-title">
              {t("tour.program_tour")}
            </Title>
          </Col>
          {hiddenCount > 0 && !showAllDays && (
            <Col>
              <Button
                type="link"
                className="tour-detail__view-all-link"
                onClick={() => setShowAllDays(true)}
              >
                {t("tour.view_all_program")}
              </Button>
            </Col>
          )}
        </Row>
        <Row gutter={[0, 10]} className="passenger__form--row tour-detail__program-list">
          {visibleItinerary.map((program) => (
            <Col span={24} key={`${program.day}-${program.title}`}>
              <TourProgramItem program={program} />
            </Col>
          ))}
        </Row>
      </Card>
    </Col>
  )
}

export default TourProgram
